import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { TableList, Loader, Button } from '@ederzadravec/jade-ui';
import { FaCheckDouble, FaCheck } from 'react-icons/fa';

import { FormQuiz, Text, Modal } from 'components';
import { ListQuizzeResume } from './';
import { useService } from 'service';

const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: auto;
  margin-bottom: 24px;
`;

const IconVisible = styled(FaCheckDouble)`
  margin: 0 0 0 8px;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

const IconNotVisible = styled(FaCheck)`
  margin: 0 0 0 8px;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.black.main};
`;

const ModalResume = ({ data }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <>
      <Text type="link" size="16" onClick={() => setShowModal(!showModal)}>
        Exibir
      </Text>
      {showModal && (
        <Modal title="Resumo do Quiz" onClose={() => setShowModal(!showModal)}>
          <ListQuizzeResume idQuiz={data?._id} />
        </Modal>
      )}
    </>
  );
};

const Update = ({ data, refresh }) => {
  const RouteParams = useParams();
  const [, { loading }, updateVisibleQuiz] = useService(
    'patch',
    `/room/${RouteParams.room}/quiz/${data._id}/active`,
    {},
    false
  );

  const handleOnIsVisible = async (id, visible) => {
    await updateVisibleQuiz({
      _id: id,
      isVisible: !visible,
    });

    refresh();
  };

  if (loading) return null;

  return (
    <Text
      type="link"
      color="black"
      center
      onClick={() => handleOnIsVisible(data._id, data.isVisible)}>
      {data.isVisible === false ? <IconNotVisible /> : <IconVisible />}
    </Text>
  );
};

export const Quiz = () => {
  const [showForm, setShowForm] = React.useState(false);

  const RouteParams = useParams();

  const [quizzesData, { loading }, refreshQuiz] = useService(
    'get',
    `/room/${RouteParams.room}/quiz`
  );

  const handleOnCloseForm = refresh => {
    setShowForm(false);

    if (refresh) refreshQuiz();
  };

  const listConfig = [
    {
      name: 'Name',
      size: { md: 8 },
      dataPath: 'name.pt',
    },
    {
      name: 'Ação',
      size: { md: 2 },
      dataPath: data => <Update data={data} refresh={refreshQuiz} />,
    },
    {
      name: 'Resumo',
      size: { md: 2 },
      dataPath: data => <ModalResume data={data} />,
    },
  ];

  const quizzes = quizzesData?.success?.quizzes?.data || [];

  return (
    <>
      <Loader show={loading} direction="column">
        <TableList config={listConfig} data={quizzes} />
      </Loader>

      <Footer>
        <Button onClick={() => setShowForm(true)}>Novo</Button>
      </Footer>

      {showForm && <FormQuiz onClose={handleOnCloseForm} id_room={RouteParams.room} />}
    </>
  );
};
